<template>
  <v-container grid-list-md text-md-center>
    <Loading v-model="loading"></Loading>
    <v-layout row wrap>
      <v-flex xl8 offset-xl2 xs12>
        <div class="Title">
          マイページ
        </div>
      </v-flex>


      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle"><span>お知らせ</span></div>
        <template v-for="info in eventInfoConditionalTextsOrdered" v-if="rule(info)">
          <p class="text-left" v-html="info.text"></p>
        </template>
      </v-flex>

      <v-flex xl8 offset-xl2 xs12 v-if="canShowWrittenResult && me.entryStatus == 'ACCEPTED'"
              id="result">
        <div class="subTitle"><span>試験結果</span></div>
        <p>{{ event.eventName }}の結果について、次のとおり通知します。</p>

        <v-btn rounded
               color="primary"
               :to="`/api/visitor/${event.id}/result`"
               target="_blank"
               class="white--text buttonStyle">試験結果ダウンロード
        </v-btn>

        <div v-if="me.examResult.writtenResult == '合格'" class="ma-4">
<!--          <h2 class="mt-5">合格証書</h2>-->
          <v-btn rounded large
                 color="primary"
                 style="font-size: 22px"
                 :to="`/api/visitor/${event.id}/certificate`"
                 target="_blank"
                 class="white--text buttonStyle">合格証書ダウンロード
          </v-btn>
        </div>

        <div v-if="me.examResult.writtenResult == '基礎試験合格'" class="ma-4">
          <!--          <h2 class="mt-5">合格証書</h2>-->
          <v-btn rounded large
                 color="primary"
                 style="font-size: 22px"
                 :to="`/api/visitor/${event.id}/certificate_foundation`"
                 target="_blank"
                 class="white--text buttonStyle">基礎試験合格証書ダウンロード
          </v-btn>
        </div>

        <v-flex v-if="!!me.submittedAt && canUploadDocuments">
          <UploadDocument></UploadDocument>
        </v-flex>

      </v-flex>


      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle">
          <span>登録情報</span>
        </div>
      </v-flex>
      <v-flex xl8 offset-xl2 xs12>
        <v-text-field label="メールアドレス" :value="me.username" readonly class="mx-5"
                      append-icon="mdi-pencil"
                      @click:append="changeEmailModal = true"
        >
          <template v-slot:append>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="changeEmailModal = true">
                  <v-icon v-bind="attrs" v-on="on">mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>メールアドレスの変更</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="changePasswordModal = true">
                  <v-icon v-bind="attrs" v-on="on">mdi-account-key</v-icon>
                </v-btn>
              </template>
              <span>パスワードの変更</span>
            </v-tooltip>

            <!--            <v-btn color="primary" text @click="changeEmailModal = true">メールアドレスの変更</v-btn>-->
            <!--            <v-btn color="primary" text>パスワードの変更</v-btn>-->
          </template>
        </v-text-field>
        <!--          </v-col>-->
        <!--        </v-row>-->

      </v-flex>
      <template v-if="canShowWrittenTicket && accepted">
      <v-flex xl8 offset-xl2 xs12 >
        <h3 class="mt-5">受験番号 {{ me.examineesNumber }}</h3>

<!--        <v-img :src="`/api/visitor/me/${event.id}/qr`" width="150" height="150" class="ma-auto"></v-img>-->

        <v-btn rounded
               v-if="me.examResult && me.examResult.hasRetest && canShowRetestWrittenTicket"
               :disabled="!canShowWrittenTicket"
               color="primary"
               :to="`/api/visitor/${event.id}/retest`"
               target="_blank"
               class="white--text buttonStyle">再試験受験票ダウンロード
        </v-btn>
        <v-btn rounded
               v-else
               :disabled="!canShowWrittenTicket"
               color="primary"
               :to="`/api/visitor/${event.id}/ticket`"
               target="_blank"
               class="white--text buttonStyle">受験票ダウンロード
        </v-btn>
      </v-flex>
      <v-flex xl8 offset-xl2 xs12 v-if="me.entry && me.entry.considerationFixed">
        <v-container class="align-center text-center" >
          <v-textarea readonly v-model="me.entry.considerationFixed"
                      label="決定した特別措置"
          >
          </v-textarea>
        </v-container>
      </v-flex>
      </template>

      <v-container>
      </v-container>
      <v-flex xl8 offset-xl2 xs12>
        <div class="subTitle"><span>願書申請状況</span></div>

        <p class="info-text" v-if="eventInfo.myPageNotice" v-html="eventInfo.myPageNotice">
        </p>
        <template v-else>
          <div>【電子申請入力の注意事項】</div>
          <p class="text-caption text-left">
            願書申請の手順は下記のとおりです。注意事項をご確認の上、申請してください。<br>
            【願書申請手順】<br>
            　①受験者情報の登録<br>
            　②受験科目・希望受験地・免除申請の登録<br>
            　③受験手数料お支払いの手続き<br>
            　④願書の提出<br>
            <br>
            【登録状況の確認方法】<br>
            　各項目の右側のマークでご確認いただけます。<br>


            　
            <v-icon color="gray">mdi-check-circle</v-icon>
            黒チェックマーク：登録未完了（必須項目に未入力、未登録の項目がある状況です）<br>
            　
            <v-icon color="green">mdi-check-circle</v-icon>
            緑チェックマーク：登録完了（必須項目が全て入力・登録され、願書提出ができる状況です）<br>
            　<span style="border-radius: 50%" class="v-stepper__step__step primary">
          <v-icon color="white">edit</v-icon></span>鉛筆マーク：登録内容の修正・変更が可能<br>
          </p>
        </template>

        <v-stepper
            v-model="stepper"
            vertical
            flat
        >
          <v-stepper-step
              :complete="entryOk"
              step="1"
              editable
              class="open_force"
          >
            <span>受験者情報の登録
            <v-icon color="green" v-if="entryOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
            </span>
          </v-stepper-step>

          <v-stepper-content step="1">
            <v-btn color="primary" to="/entry" rounded
                   class="white--text buttonStyle">登録画面に進む
            </v-btn>
          </v-stepper-content>

          <v-stepper-step
              editable
              :complete="subjectOk"
              step="2"
              class="open_force"
          >
            <span>
            受験科目・希望受験地・免除申請の登録
            <v-icon color="green" v-if="subjectOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
            </span>
          </v-stepper-step>

          <v-stepper-content step="2">
            <v-btn color="primary" to="/select" rounded
                   class="white--text buttonStyle">登録画面に進む
            </v-btn>


          </v-stepper-content>

          <v-stepper-step
              :complete="!!me.ticketOrder"
              step="3"
          >
            <span>
<!--            受験手数料支払い手続き-->
              願書提出
            <v-icon color="green" v-if="paymentOk">mdi-check-circle</v-icon>
            <v-icon color="gray" v-else>mdi-check-circle</v-icon>
              </span>
          </v-stepper-step>

          <v-stepper-content step="3">
            <template v-if="entryOpened || isPre">
              <div v-if="ticket" >
                <p>
                  {{ ticket.name }} {{ ticket.description }}<span class="d-none">：{{ ticket.price }} 円(税込)</span>
                </p>

                <p class="red--text text-left px-16">願書提出ボタンを押す前には、今一度、受験内容と金額をご確認ください。</p>
                <ShunyuInshi />

                <v-btn color="primary" :disabled="!canSubmit" @click.stop="submit"
                       style="height: auto"
                       class="white--text pa-3" rounded>
                  <!--                決済を確定して願書を提出する-->
                  <!--                願書を提出する-->
                  別途収入印紙を郵送し、収入印紙が事務局に到着した後<br />
                  受験資格が得られることに同意し、<br />
                  願書を提出する
                </v-btn>
              </div>


            </template>
            <template v-else>
              <p>提出可能期間ではありません</p>
            </template>

          </v-stepper-content>


          <v-stepper-step step="4">
            <span>受付状況</span>
          </v-stepper-step>
          <v-stepper-content step="4" class="open_force">
            <div v-if="!!me.submittedAt">
              <div v-if="me.entryStatus == 'ACCEPTED'">
                受付状況：完了
              </div>
              <div v-else-if="me.entryStatus == 'WAIT_FOR_RESUBMIT'">
                <p class="mb-16">受付状況：再提出待ち</p>
                <p class="red--text">登録内容の修正完了後、下記「願書を再提出する」ボタンをクリックしてください</p>
                <v-btn color="primary" :disabled="!canReSubmit" @click.stop="resubmit" rounded
                       class="white--text buttonStyle">願書を再提出する
                </v-btn>
                <p class="red--text" v-if="!canReSubmit">登録内容の修正が確認できません</p>
              </div>
              <div
                  v-else-if="me.ticketOrder && me.ticketOrder.paymentMethod == 'SONYPAYMENT_CONVENIENCE_STORE' && me.ticketOrder.result == 'WaitForPayment'">
                <div>
                  受付状況：決済完了待ち
                </div>
              </div>
              <div v-else-if="me.entryStatus == 'PENDING' || me.entryStatus == 'HOLD' || me.entryStatus == 'REJECTED'">
                <ShunyuInshi />
                受付状況：審査中
              </div>
              <div v-else>
                <ShunyuInshi />
                受付状況：審査中
              </div>
              <template
                  v-if="me.ticketOrder && me.ticketOrder.paymentMethod == 'SONYPAYMENT_CONVENIENCE_STORE' && me.ticketOrder.result == 'WaitForPayment'">
                <v-btn class="primary" to="/api/status/convenience_payment_url" target="_blank" tag="a">
                  コンビニ決済ページへ
                </v-btn>
              </template>
            </div>
          </v-stepper-content>
        </v-stepper>



        <!--        <div class="subTitle"><span>領収書</span></div>-->

        <!--        <v-flex xl8 offset-xl2 xs12 v-if="me.ticketPrice > 0">-->
        <!--          <p class="text-xs-center">-->
        <!--            <v-btn-->
        <!--              color="primary"-->
        <!--              class="white&#45;&#45;text buttonStyle"-->
        <!--              @click="downloadReceipt"-->
        <!--              rounded-->
        <!--            >-->
        <!--              領収書ダウンロード-->
        <!--            </v-btn>-->
        <!--          </p>-->
        <!--        </v-flex>-->

        <!--        <div class="subTitle"><span>試験結果</span></div>-->


        <!--        <div class="subTitle">-->
        <!--          <span>お問い合わせ先</span>-->
        <!--        </div>-->
        <!--        <p class="text-left pa-5">-->
        <!--          ＜全国通訳案内士試験事務局＞<br>-->
        <!--          TEL. 04-7131-6200<br>-->
        <!--          （土・日・祝・年末年始除く10：00～17：00）<br>-->
        <!--          ▶お問い合わせは、<a href="https://mdr0028.maildealer.jp/f.php?c=8&s=71bb" target="_blank">こちら</a>からお願いいたします。-->
        <!--        </p>-->
        <!--        <p class="text-left text-caption">-->
        <!--          日本政府観光局(JNTO)は、2023年度の全国通訳案内士試験に係る事務手続き、<br>-->
        <!--          試験運営業務等を日販セグモ株式会社に委託しています。-->
        <!--        </p>-->

      </v-flex>

      <AccountEdit v-model="changeEmailModal"></AccountEdit>
      <PasswordEdit v-model="changePasswordModal"></PasswordEdit>

    </v-layout>

    <!--    <v-dialog-->
    <!--      v-model="dialog"-->
    <!--      persistent-->
    <!--      max-width="640"-->
    <!--    >-->
    <!--      <v-card>-->
    <!--        <v-card-title class="text-h5 font-weight-bold">-->
    <!--          【ご案内】-->
    <!--        </v-card-title>-->
    <!--        <v-card-text class="text-left" style="font-size: 1rem; line-height: 1.5rem">-->
    <!--          <span style="color: red">マイページは2023年2月28日まで閲覧が可能</span>ですが、<span style="color: red">2023年3月1日以降は閲覧できなくなります。</span><br/>-->
    <!--          以降のマイページ閲覧や掲載情報の問い合わせ等には応じられませんので、下記が必要な方は<span-->
    <!--          style="color: red">ご自身で必ず上記期日までにご対応ください。</span><br/>-->
    <!--          ・<span style="color: red">受験番号や試験結果</span>をお控えください。<br/>-->
    <!--          ・<span style="color: red">合格証書、筆記試験合格証書を印刷し、紛失しないよう保管してください。</span><br/>-->
    <!--          <br/>-->
    <!--          <p class="text-right">※本画面を閉じる場合は下記の「<span style="color: #43A047">閉じる</span>」をクリックしてください。</p>-->
    <!--        </v-card-text>-->
    <!--        <v-card-actions>-->
    <!--          &lt;!&ndash;          <v-checkbox label="以後表示しない" v-model="noDialog"></v-checkbox>&ndash;&gt;-->
    <!--          <v-spacer></v-spacer>-->
    <!--          <v-btn-->
    <!--            color="green darken-1"-->
    <!--            text-->
    <!--            @click="dialog = false"-->
    <!--          >-->
    <!--            閉じる-->
    <!--          </v-btn>-->
    <!--        </v-card-actions>-->
    <!--      </v-card>-->
    <!--    </v-dialog>-->
  </v-container>
</template>
<script>
import {getReceiptUrl, getTickets} from '../../utils/VisitorAPIUtils'
import axios from 'axios'
import Loading from '../components/Loading'

import {mapGetters} from 'vuex'
import AccountEdit from '../components/AccountEdit'
import PasswordEdit from '../components/PasswordEdit'
import dayjs from 'dayjs'
import _ from 'lodash';
import ShunyuInshi from "@/event/components/ShunyuInshi.vue";
import UploadDocument from "@/event/components/UploadDocument.vue";

export default {
  components: {UploadDocument, ShunyuInshi, PasswordEdit, Loading, AccountEdit},
  props: {
    event_data: Object,
  },
  data() {
    return {
      loading: true,
      stepper: 1,
      tickets: [],
      callbackToken: null,
      callbackCard: null,
      paymentMethod: "manual",
      // paymentOk: false,
      changeEmailModal: false,
      changePasswordModal: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters([
      'event', 'eventInfo', 'me', 'accepted', 'entryOpened', 'isPre'
    ]),
    entryOk() {
      return this.me && this.me.entry && !!this.me.entry.submittedAt
    },
    subjectOk() {
      return this.me && this.me.subjectEntry && !!this.me.subjectEntry.submittedAt
    },
    paymentOk() {
      return this.me && !!this.me.ticketId
    },
    canSubmit() {
      let ret = this.entryOk && this.subjectOk && !!this.ticket && (this.entryOpened || this.isPre)
      if (this.paymentMethod == 'card') {
        return ret && !!this.callbackToken
      }
      return ret
    },
    canReSubmit() {
      let ret = this.entryOk && this.subjectOk
      if (_.has(this.me, "resubmitRequestedAt")) {
        let isChanged = dayjs(_.get(this.me, "entry.submittedAt")).isAfter(this.me.resubmitRequestedAt)
            || dayjs(_.get(this.me, "subjectEntry.submittedAt")).isAfter(this.me.resubmitRequestedAt)
        ret = ret && isChanged
      }
      return ret
    },
    ticket() {
      let ticketCode = null
      let requestedSubjects = (this.me.subjectEntry && this.me.subjectEntry.requestedSubjects) || false
      switch (requestedSubjects.length){
        case 0:
          ticketCode = "NoExemptionWithManual"
          break;
        case 1:
          ticketCode = "OneExemptionWithManual"
          break;
        case 2:
          ticketCode = "TwoExemptionsWithManual"
          break;
      }
      return this.tickets.find(v => v.code == ticketCode)
    },
    canShowWrittenTicket() {
      let target = this.event.timeline && this.event.timeline.writtenExamTicketOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowRetestWrittenTicket() {
      let target = this.event.timeline && this.event.timeline.retestExamTicketOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowWrittenResult() {
      let target = this.event.timeline && this.event.timeline.writtenExamResultOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowOralTicket() {
      let target = this.event.timeline && this.event.timeline.oralExamTicketOpenAt
      return !!target && dayjs().isAfter(target)
    },
    canShowOralResult() {
      let target = this.event.timeline && this.event.timeline.oralExamResultOpenAt
      return !!target && dayjs().isAfter(target)
    },
    noDialog: {
      get() {
        return localStorage.getItem('noDialog')
      },
      set(v) {
        localStorage.setItem('noDialog', v);
      }
    },
    eventInfoConditionalTextsOrdered() {
      return (this.eventInfo.conditionalTexts || []).sort((a, b) => {
        if (!a.viewOrderRank) return 1
        if (!b.viewOrderRank) return -1
        return a.viewOrderRank - b.viewOrderRank
      })
    },
    canUploadDocuments(){
    //TODO:XXX
      return dayjs().isBefore("2025-05-01")
    }
  },
  async created() {
    this.loading = true
    await this.$store.dispatch('getMe')
    this.stepper = this.initStepper()

    getTickets({eventId: this.event_data.id}).then(res => {
      this.tickets = res.data
      // this.setTicketStatus();
    }).catch(err => {
      console.log('get tickets catch error. ', err)
    })
    this.loading = false
    // if (!this.noDialog) {
    //   this.dialog = true
    // }
  },
  methods: {
    initStepper() {
      if (!this.entryOk) return 1
      if (!this.subjectOk) return 2
      if (!this.me.ticketOrder) return 3
      return 4
    },
    openCardInput() {
      if (window.SpsvApi) {
        window.SpsvApi.spsvCardInfoScreen()
      } else {
        alert('決済ライブラリーの読み込みに失敗しました。時間をあけて再度お試しください')
      }
    },
    async authCard() {
      try {
        await axios.post('/api/status/auth', {
          token: this.callbackToken
        })
        // this.$emit('toast', 'オーソリ成功')
      } catch (e) {
        this.$emit('error', 'こちらのカードはご使用になれません')
      }
    },
    async gatheringCard() {
      try {
        await axios.post('/api/status/gathering', {
          token: this.callbackToken
        })
        this.$emit('toast', '決済が完了しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e, e.response)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
        }
        this.$emit('error', '決済に失敗しました。' + code)
      }
    },
    async openConveniencePayment() {
      try {
        let {data} = await axios.post('/api/status/add_cnv')
        console.error(data)
        this.$emit('toast', data)
        // return this.getMe()
        window.open(data, 'payment')
        return
      } catch (e) {
        console.error(e, e.response)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
        }
        this.$emit('error', '決済に失敗しました。' + code)
      }
    },
    async submit() {
      this.loading = true
      try {
        await axios.post('/api/status/submit', {
          paymentMethod: this.paymentMethod,
          maskedCardNumber: this.callbackCard,
          token: this.callbackToken
        })
        this.$emit('toast', '提出しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e)
        let code = ''
        if (e.response && e.response.data) {
          code = 'エラーコード:' + e.response.data
          this.$emit('error', '決済に失敗しました。' + code)
        } else {
          this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
        }
      } finally {
        this.loading = false
      }
    },
    async resubmit() {
      if (!window.confirm("再提出をしてもよろしいですか？")) {
        return false;
      }
      this.loading = true
      try {
        await axios.post('/api/status/resubmit')
        this.$emit('toast', '提出しました')
        await this.$store.dispatch('getMe')
        this.stepper = this.initStepper()
        return
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      } finally {
        this.loading = false
      }
    },
    edit() {

    },
    downloadReceipt() {
      let url = getReceiptUrl({eventId: this.event_data.id})
      window.location.href = url
    },
    rule(info) {
      try {
        return _.get(this.me, info.condition) == info.conditionValue
      } catch (e) {
        console.log(e)
      }
    },
    isLang2writtenResultFailed(me) {
      let detail = me.examResult.resultDetail
      return [detail.writtenGeographyResult,
        detail.writtenHistoryResult,
        detail.writtenCommonSenseResult,
        detail.writtenPracticeResult].some(value => value == '不合格')
    }
  }
}
</script>
<style lang="scss">
.Title {
  font-size: 150%;
}

.subTitle {
  position: relative;
  text-align: left;
  font-size: 130%;
  font-weight: bold;
  color: #959595;
}

.subTitle:before {
  border-top: 1px solid;
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
}

.subTitle span {
  background-color: white;
  display: inline-block;
  padding: 0 0.5em;
  position: relative;
}

.subContentsTitle {
  font-size: 100%;
}

.buttonStyle {
  width: 50%;
}

.open_force.v-stepper__step--editable + .v-stepper__content .v-stepper__wrapper {
  height: auto !important;
}

.resultScore {
  padding-right: 1em;
  text-align: right;
}
</style>
